<template>
  <div class="page-content">
    <div class="intro-content">
      <img src="@/assets/images/intro-bg.jpg" class="intro-bg" alt="image description"/>
      <h1>get real. california quiz. </h1>
      <a href="#" class="btn-next" @click.prevent="next">
        <span>play</span>
      </a>
    </div>
    <div class="logo-row-bottom">
      <div class="logo-holder">
        <img src="@/assets/images/ymi.png" width="53" height="43" alt="image description">
      </div>
      <div class="logo-holder">
        <img src="@/assets/images/got-milk.png" width="191" height="55" alt="image description">
        <p class="copy">&copy; 2024 California Milk Processor Board</p>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapMutations } from "vuex";

  export default {
    name: "Intro",
    methods: {
      ...mapMutations({
        next: 'nextStep',
      }),
    },
    mounted() {
      window.dispatchEvent(new Event('resize'));

      window.addEventListener("load", function(){
        document.body.classList.add('loaded');
      });
    }
  }
</script>
